module.exports = __webpack_public_path__ + "static/media/we-offer-bg.f9728932.png";